var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import GL, { WidthProvider } from "react-grid-layout";
import { connect } from "react-redux";
import { HomePageWidgetTypes } from "@irati/types";
import Image from "./widgets/Image";
import WrongType from "./widgets/WrongType";
import ImageWithText from "./widgets/ImageWithText";
import Video from "./widgets/Video";
import "../../../../../../../node_modules/react-grid-layout/css/styles.css";
import "../../../../../../../node_modules/react-resizable/css/styles.css";
import { StyledGridLayoutWrapper } from "./styled/styled";
var GridLayout = WidthProvider(GL);
var rowHeight = {
    large: 151,
    medium: 123,
    small: 169
};
var Desktop = /** @class */ (function (_super) {
    __extends(Desktop, _super);
    function Desktop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hoverActive: null,
            isOnDrag: false
        };
        _this.onMouseEnter = function (widgetId) {
            var _a = _this.props, editMode = _a.editMode, editingTileActive = _a.editingTileActive;
            if (!editMode || editingTileActive)
                return;
            _this.setState({ hoverActive: widgetId });
        };
        _this.onMouseLeave = function () {
            if (_this.props.editMode) {
                _this.setState({ hoverActive: null });
            }
        };
        _this.isWidgetSmallSquare = function (widgetId) {
            var layout = _this.props.layout;
            // get width and height of widget from layout
            var _a = layout.find(function (elem) { return elem.i === widgetId; }), w = _a.w, h = _a.h;
            return w * h === 1;
        };
        return _this;
    }
    Desktop.prototype.render = function () {
        var _this = this;
        var _a = this.props, layout = _a.layout, widgets = _a.widgets, isLarge = _a.isLarge, isMedium = _a.isMedium, handleOnGridChange = _a.handleOnGridChange, removeTileFromGrid = _a.removeTileFromGrid, editTile = _a.editTile, editMode = _a.editMode, onClick = _a.onClick;
        var _b = this.state, hoverActive = _b.hoverActive, isOnDrag = _b.isOnDrag;
        var size = isLarge && "large" || isMedium && "medium" || "small";
        return (React.createElement(StyledGridLayoutWrapper, null,
            React.createElement(GridLayout, { layout: layout, cols: 4, containerPadding: [0, 0], margin: [15, 15], rowHeight: rowHeight[size], onDragStart: function () { return _this.setState({ isOnDrag: true }); }, onDragStop: function () { return _this.setState({ isOnDrag: false }); }, onLayoutChange: function (newLayout) {
                    handleOnGridChange(newLayout);
                } }, widgets.map(function (_a) {
                var i = _a.i, image = _a.image, header = _a.header, body = _a.body, type = _a.type, link = _a.link, openLinkInNewTab = _a.openLinkInNewTab, videoUrl = _a.videoUrl;
                switch (type) {
                    case HomePageWidgetTypes.Image:
                        return (React.createElement("div", { key: i, onMouseEnter: function () { return _this.onMouseEnter(i); }, onMouseLeave: _this.onMouseLeave },
                            React.createElement(Image, { widgetId: i, isOnDrag: isOnDrag, image: image, link: link, openLinkInNewTab: openLinkInNewTab, editMode: editMode, hoverActive: hoverActive === i, onClick: onClick, removeTileFromGrid: removeTileFromGrid, smSquare: _this.isWidgetSmallSquare(i), editTile: editTile })));
                    case HomePageWidgetTypes.ImageWithText:
                        return (React.createElement("div", { key: i, onMouseEnter: function () { return _this.onMouseEnter(i); }, onMouseLeave: _this.onMouseLeave },
                            React.createElement(ImageWithText, { widgetId: i, isOnDrag: isOnDrag, image: image, body: body, header: header, link: link, onClick: onClick, openLinkInNewTab: openLinkInNewTab, editMode: editMode, hoverActive: hoverActive === i, editTile: editTile, removeTileFromGrid: removeTileFromGrid })));
                    case HomePageWidgetTypes.Video:
                        return (React.createElement("div", { key: i, onMouseEnter: function () { return _this.onMouseEnter(i); }, onMouseLeave: _this.onMouseLeave },
                            React.createElement(Video, { editTile: editTile, hoverActive: hoverActive === i, isOnDrag: isOnDrag, onClick: onClick, removeTileFromGrid: removeTileFromGrid, videoUrl: videoUrl, widgetId: i })));
                    default:
                        return (React.createElement("div", { key: i },
                            React.createElement(WrongType, null)));
                }
            }))));
    };
    return Desktop;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isLarge: mq.greaterThan.large,
        isMedium: mq.greaterThan.medium
    };
};
export default connect(mapStateToProps)(Desktop);
